import { render, staticRenderFns } from "./OrderServicePage.vue?vue&type=template&id=2db18b19&"
import script from "./OrderServicePage.vue?vue&type=script&lang=js&"
export * from "./OrderServicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports